import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getArticleTemplateById } from "../../app/services/articleTemplateService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Form from "react-bootstrap/Form";
import {
    Breadcrumb,
    Button,
    Col,    
    Row,
} from "react-bootstrap";
import moment from "moment";

import { ArticleType } from "../../models/enums/articleTypeEnum";

interface Props { }

const ArticleTemplateView: FC<Props> = () => {
    moment.locale("sv");
    const { articleTemplateId } = useParams<{ articleTemplateId: string }>();
    const dispatch = useAppDispatch();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const articleTemplateData = useSelector((state: RootState) => state.articleTemplate);

    useEffect(() => {
        dispatch(getArticleTemplateById(instance, account, articleTemplateId));
    }, [account, accounts, dispatch, instance, articleTemplateId]);

    return (
        <div>
            <Breadcrumb>
                <Breadcrumb.Item href="/admin/article-templates">Artikelmallar</Breadcrumb.Item>
                <Breadcrumb.Item active>{articleTemplateId}</Breadcrumb.Item>
            </Breadcrumb>
            <hr />
            <Form>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Artikelnummer</Form.Label>
                            <Form.Control
                                type="text"
                                value={articleTemplateData.articleTemplate.articleNumber}
                                readOnly
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Beskrivning</Form.Label>
                            <Form.Control
                                type="text"
                                value={articleTemplateData.articleTemplate.description}
                                readOnly
                                disabled
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Pris</Form.Label>
                            <Form.Control
                                type="text"
                                value={articleTemplateData.articleTemplate.salesPrice}
                                readOnly
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Typ</Form.Label>
                            <Form.Control
                                type="text"
                                value={ArticleType[articleTemplateData.articleTemplate.articleType as ArticleType]}
                                readOnly
                                disabled
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3">
                              <Form.Check
                                type="checkbox"
                                label="Använd ursprungligt pris"
                                checked={articleTemplateData.articleTemplate.keepIncomingPrice}
                                readOnly
                                disabled
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Form>

            <Row>
                <div className="text-end">
                    <Button variant="primary" href={`/admin/article-templates/${articleTemplateId}/edit`}>
                        Redigera
                    </Button>
                </div>
            </Row>

        </div>
    );
};

export default ArticleTemplateView;
